import request from '@/utils/request';

/**
 * 获取多来目标定结果
 */
export async function calibrateDuolaimuRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/toramon/list',
    method: 'GET',
    params
  });
}

/**
 * 获取园之云相机标定结果
 */
export async function calibrateYuanzhiyunCameraRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/yzy/camera/list',
    method: 'GET',
    params
  });
}


/**
 * 获取园之云雷达标定结果
 */

export async function calibrateYuanzhiyunRadarRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/yzy/radar/list',
    method: 'GET',
    params
  });
}

/**
 * 获取拉线电机标定结果
 */

export async function calibrateLaxianMotorRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/motor/list',
    method: 'GET',
    params
  });
}

/**
 * 获取Aqi Ins 标定结果
 */

export async function calibrateAqiInsRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/aq/list',
    method: 'GET',
    params
  });
}

/**
 * 获取BSD激光雷达标定结果
 */

export async function calibrateBsdLaserRadarRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/laser/list',
    method: 'GET',
    params
  });
}

/**
 * 获取安行前向相机标定结果
 */

export async function calibrateAxForwardCameraRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/ax/camera/list',
    method: 'GET',
    params
  });
}

/**
 * 获取安行前向毫米波雷达标定结果
 */

export async function calibrateAxForwardMmwRadarRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/ax/mmw/radar/list',
    method: 'GET',
    params
  });
}

/**
 * 获取安行DMS相机标定结果
 */

export async function calibrateAxDmsCameraRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/ax/dms/camera/list',
    method: 'GET',
    params
  });
}

/**
 * 获取安行BSD相机标定结果
 */

export async function calibrateAxBsdCameraRequest(params: any) {
  return request({
    url: '/api/v2/deviceInfo/calibration/ax/bsd/camera/list',
    method: 'GET',
    params
  });
}
